module.exports = __webpack_public_path__ + "img/touring-pitches-no.e4621be.svg";